function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value.seconds === 'number') return new Date(value.seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Feature ativa: active true e, se houver datas, o instante atual está no intervalo.
 * dateStart e dateFinal são inclusivos. Sem o documento, a feature está inativa.
 */
export function isFeatureActive(feature, now = new Date()) {
  if (!feature || feature.active !== true) return false;
  const start = toDate(feature.dateStart);
  const end = toDate(feature.dateFinal);
  const instant = now instanceof Date ? now : new Date(now);
  if (start && instant < start) return false;
  if (end && instant > end) return false;
  return true;
}
